import React from 'react';
import { Layout, Typography, Button, Row, Col, Card } from 'antd';
import { Link } from 'react-router-dom';
import {
  HomeOutlined,
  TeamOutlined,
  BarChartOutlined,
  LoginOutlined
} from '@ant-design/icons';

const { Content } = Layout;
const { Title, Paragraph } = Typography;

const LandingPage = () => {
  return (
    <Layout>
      <Content style={{ padding: '100px 50px 50px' }}>
        <div style={{ textAlign: 'center', marginBottom: 60 }}>
          <Title level={1}>ระบบสารสนเทศคณะสงฆ์ ภาค ๔-๕ (ธรรมยุต) - E-Sangha Information Hub</Title>
          <Paragraph style={{ maxWidth: 600, margin: '0 auto' }}>
            ระบบบริหารจัดการข้อมูลวัด พระสงฆ์ และผู้ใช้งานในองค์กรสงฆ์
            พร้อมทั้งแสดงผลแนวโน้มและสถิติภาพรวมอย่างครบถ้วน
          </Paragraph>
          <Button type="primary" size="large" icon={<LoginOutlined />}>
            <Link to="/login">เริ่มต้นใช้งาน</Link>
          </Button>
        </div>

        <Row gutter={[24, 24]} justify="center">
          <Col xs={24} md={8}>
            <Card
              hoverable
              cover={<HomeOutlined style={{ fontSize: 64, textAlign: 'center', paddingTop: 20 }} />}
            >
              <Card.Meta title="จัดการวัด" description="เพิ่ม แก้ไข ลบข้อมูลวัดได้อย่างง่ายดาย" />
            </Card>
          </Col>
          <Col xs={24} md={8}>
            <Card
              hoverable
              cover={<TeamOutlined style={{ fontSize: 64, textAlign: 'center', paddingTop: 20 }} />}
            >
              <Card.Meta title="ข้อมูลพระสงฆ์" description="บริหารจัดการประวัติ การศึกษา สมณศักดิ์" />
            </Card>
          </Col>
          <Col xs={24} md={8}>
            <Card
              hoverable
              cover={<BarChartOutlined style={{ fontSize: 64, textAlign: 'center', paddingTop: 20 }} />}
            >
              <Card.Meta title="สถิติ & รายงาน" description="วิเคราะห์ข้อมูลผ่านกราฟภาพรวม" />
            </Card>
          </Col>
        </Row>
      </Content>

    </Layout>
  );
};

export default LandingPage;
